export default __webpack_public_path__ + "static/media/survey_vault.c3973540.svg";